import styled from "styled-components";

import { default as ChevronDownIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/chevronDown/12";

interface AccessoryStyleProps {
    isExpanded?: boolean;
    currentRotation?: number;
}

export const ToingStampContainer = styled.div({
    position: "absolute",
    top: "-10px",
    right: "-16px",
});

export const ChevronContainer = styled.div(({ theme }) => ({
    marginLeft: `calc(${theme.spacing.xxxSmall} + ${theme.spacing.xSmall})`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
    flexShrink: 0,
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
}));

export const Chevron = styled.div<AccessoryStyleProps>(({ theme, currentRotation, isExpanded }) => ({
    transform: `rotate(${currentRotation ?? 0}deg)`,
    transition: isExpanded ? "transform 0.4s ease-out" : "transform 0.4s ease-in",
    color: theme.colors.light.text_Med_Emphasis,
    height: theme.spacing.large,
}));

export const ChevronIcon = styled(ChevronDownIcon)(({ theme }) => ({
    fill: "unset",
    marginTop: theme.spacing.xxSmall,
}));
